require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/modules/es7.symbol.observable.js
// module id = 138
// module chunks = 0